import { useLicenseWarning } from '@/models/driver'

interface LicenseNumberWarningProps {
  licenseNumber: string
  licenseState: string
}

/** The confirm step's note on a licence's format, shown while it's typed; it never blocks a save. */
export function LicenseNumberWarning({ licenseNumber, licenseState }: LicenseNumberWarningProps) {
  const warning = useLicenseWarning(licenseNumber, licenseState)
  if (!warning) return null
  // The same inline note as the trucks' VIN check-digit warning.
  return (
    <p role="status" className="text-warning-d1 mt-1 text-xs">
      {warning}
    </p>
  )
}
